import { DevilEnemy } from './DevilEnemy';
import { GoblinEnemy } from './GoblinEnemy';
export var ENEMY_TYPE;
(function (ENEMY_TYPE) {
    ENEMY_TYPE["DEVIL"] = "DEVIL";
    ENEMY_TYPE["GOBLIN"] = "GOBLIN";
})(ENEMY_TYPE || (ENEMY_TYPE = {}));
var EnemyFactory = /** @class */ (function () {
    function EnemyFactory() {
    }
    EnemyFactory.createEnemy = function (enemyType, yPosition) {
        switch (enemyType) {
            case ENEMY_TYPE.DEVIL:
                return new DevilEnemy(yPosition);
            case ENEMY_TYPE.GOBLIN:
                return new GoblinEnemy(yPosition);
            default:
                return new GoblinEnemy(yPosition);
        }
    };
    return EnemyFactory;
}());
export { EnemyFactory };
